import React, { useEffect, useContext } from "react";
import { useLocation, useNavigate, createSearchParams } from "react-router-dom";
import StoreFormContainer from "components/store-form-container";
import { getQueryParams } from "lib/utils";
import { useTranslation } from "react-i18next";
import { Header } from "components/header";
import AuthContext from "contexts/AuthContext";
import { useAddStatus } from "api/tes/useAddStatus";
import { useGetTakeback } from "api/tes/useGetTakeback";
import { calculateEstimate } from "lib/calculateEstimate";

export default function TradeInComplete() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = getQueryParams(location.search);
  const { user } = useContext(AuthContext);
  const { mutateAsync: addStatus } = useAddStatus();
  const { data: { data: { takeback } = {} } = {} } = useGetTakeback(
    queryParams.id
  );

  const isDropOff = location.pathname.includes("dropoff");

  useEffect(() => {
    const addProcessedStatus = async () => {
      try {
        await addStatus({
          id: queryParams.id,
          input: {
            parent_status: "processed",
            status: "associate-verified",
          },
        });
      } catch (error) {
        console.error("Error adding processed status:", error);
      }
    };

    if (queryParams.id) {
      addProcessedStatus();
    }
  }, [queryParams.id, addStatus, user?.email]);

  const handleDone = () => {
    if (isDropOff) {
      navigate({
        pathname: "/en-US/store/prepare-shipment/dropoff",
        search: createSearchParams(queryParams).toString(),
      });
    }
    if (!isDropOff) navigate(t("urls.store_check_in"));
  };

  const conformWeight = takeback?.data?.conform_weight || 0;
  const legoValue = calculateEstimate(conformWeight).gift;

  return (
    <StoreFormContainer
      submitLabel={isDropOff ? "Continue" : "Done"}
      onSubmit={handleDone}
      hideSecondary={true}
    >
      <Header />
      <div className="flex justify-center flex-col flex-grow py-4">
        <div className="flex flex-col items-center text-center">
          <h1 className="text-6xl font-semibold text-center mb-8">
            Trade-In complete!
          </h1>

          <p className="text-lg text-gray-600 max-w-md">
            Let the seller know their trade-in is finalized. Their{" "}
            {legoValue ? `$${legoValue}` : ``} LEGO® e-Gift Card is on the way
            via email.
          </p>
        </div>
      </div>
    </StoreFormContainer>
  );
}
